export const rootPaths = {
  tools: "/",
  rewardInventoryPortal: "/reward-inventory-portal",
  customer360: "/customer-360",
  signInRedirect: "login/callback",
  unauthorised: "/unauthorised",
  pps: "/pps",
  leadsManagement:"/leads-management",
  dna:"/dna",
  intelligenceHub:"/intelligence-hub",
  campaign: "/campaign",
};

export const rewardInventoryPortalPaths = {
  createProduct: "create-product",
  product: "product/:productId",
};

export const customer360Paths = {
  customerDetail: "customer-detail/:customerId",
};

export const leadsManagementPaths = {
  allLeads: "all-leads",
  importLeads: "import-leads",
  leadAnalytics: "lead-analytics",
  socialInsights: "social-insights",
};

export const intelligenceHubPaths = {
  socialInsights: "social-insights",
  ContentHubAnalytics: "omne-insights",
};
